module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/102/assets/images/807ca8cd09e6ed8118a8b122318e25b7.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_period.svg
// module id = JaM+
// module chunks = 0